module.exports = __webpack_public_path__ + "dist/img/doc-banner.21f42dc.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/doc-banner.jpg
// module id = qH38
// module chunks = 1